import domReady from '@wordpress/dom-ready';
import manifest from '../manifest.json';

domReady(async () => {
	const selector = `.${manifest.componentJsClass}`;
	const elements = document.querySelectorAll(selector);

	if (!elements.length) {
		return;
	}

	const { Search } = await import('./search');

	elements.forEach((element) => {
		const queryField = element.dataset.inputSelector ? document.querySelector(element.dataset.inputSelector) : element.querySelector(`.${manifest.componentJsClass}-input`);

		const search = new Search({
			element,
			resultsSelector: '.js-search-results',
			resultTemplateSelector: '.js-search-result-template',
			nothingFoundTemplateSelector: '.js-search-nothing-found',
			loaderSelector: '.js-search-loader',
			queryField,
			queryFieldButtonSelector: '.js-search-button',
			showMoreButtonSelector: '.js-search-button-more',
			resultHeadingSelector: '.js-result-heading',
			resultDescriptionSelector: '.js-result-description',
			resultQuerySelector: '.js-result-query',
			resultNumberSelector: '.js-result-number',
			resultPluralSelector: '.js-result-number-plural',
			resultQueryDescriptionSelector: '.js-result-query-description',
		});

		search.init();
	});
});
